module.exports = __webpack_public_path__ + "static/media/5.be9952f8.svg";